import * as React from 'react';
export const cibcSvg = React.forwardRef(function cibcSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#B00B1C',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFD401',
        d: 'M2.23 22.02v3.03c4.8-2.74 13.9-6.83 27.64-7.97v-.65c-10.1.56-19.64 2.46-27.64 5.59',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M2.23 26.16v2.08c6.84-5.13 16.86-8.65 27.64-9.82v-.63c-10.65.97-20 3.88-27.64 8.37',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFD401',
        d: 'M28.74 13.59c-.57.36-1.23.51-1.99.51-2.03 0-3.04-1.58-3.04-4.1 0-2.2.97-3.66 2.82-3.66.64 0 1.15.22 1.49.55.05.2.12 1.28.12 1.28h.53v-.04c0-.46.13-1.55.22-2.1l.01-.04h-.04a8.93 8.93 0 0 0-2.46-.36c-2.24 0-4.52 1.37-4.52 4.53 0 3.32 2 4.76 4.42 4.76.67 0 1.55-.1 2.26-.49l.35-.67-.14-.19-.03.02M17.53 9.51c-.29 0-.46-.02-.55-.04V7.45c0-.38.01-.72.05-.96.1-.04.41-.1.64-.1 1.1 0 1.58.48 1.58 1.5 0 1.41-1.06 1.61-1.72 1.62zm1.99 2.7c0 1.4-.77 1.96-1.93 1.96-.23 0-.47-.03-.61-.07v-3.92h.5c1.47 0 2.04.75 2.04 2.03zm-.47-2.49c1.05-.29 1.92-1.04 1.92-2.18 0-1.1-.7-1.83-2.14-1.83-.7 0-1.56.07-2.18.07-.62 0-1.27 0-2.01-.05h-.05v.5h.04c.63.06.67.18.67 1.2v6.03c0 .54-.07.8-.56.85h-.14v.5l1.74-.04c.38 0 .67.02 1.16.04 2.88.13 3.82-1.53 3.82-2.86 0-1.59-1.16-1.99-2.26-2.21v-.02zm-6.68-3.93c-.52 0-1.1 0-1.6-.05h-.05v.5h.04c.65.04.74.15.74 1.3v5.73c0 .87-.05 1-.71 1.05h-.04v.5h.04c.5-.04 1.04-.05 1.56-.05.51 0 1 0 1.54.05h.04v-.5h-.03c-.66-.04-.7-.18-.7-1.05V7.53c0-1.17.04-1.26.7-1.3h.03v-.5h-.04c-.54.04-1 .05-1.52.05m-2.34 7.81c-.57.36-1.24.51-1.99.51C6.01 14.1 5 12.52 5 10c0-2.2.97-3.66 2.82-3.66.63 0 1.15.22 1.48.55.06.2.13 1.28.13 1.28h.52v-.04c0-.46.14-1.55.23-2.1v-.04h-.03a8.9 8.9 0 0 0-2.46-.36c-2.24 0-4.52 1.37-4.52 4.53 0 3.32 2 4.76 4.42 4.76.66 0 1.54-.1 2.25-.49h.02l.34-.67-.14-.19-.03.02',
      }),
    ),
  );
});
cibcSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var cibc = {
  category: 'brand',
  colorable: false,
  name: 'cibc',
  svg: cibcSvg,
};
